//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import QfColorPicker from "../qf-color-picker.vue";
// import colors from "./colors";

export default {
    name: "QfPColors",
    components: { QfColorPicker },
    props: {
        value: { type: String },
        label: { type: String, default: "Color" },
        disable: { type: Boolean, default: false },
        custom: { type: Boolean, default: true },
        colorDefaultLabel: { type: String, default: "" }
    },
    data() {
        return {
            localValue: null,
            color: null,
            customColor: null
        };
    },
    computed: {
        ...mapState("components", ["defaultColors", "colorValue"]),
        colorCollection() {
            return [...this.colorsToOptions(this.defaultColors)];
        },
        options() {
            const colorOptions = [];

            if (this.custom) {
                colorOptions.push(
                    ...(this.colorDefaultLabel ? [] : [{ label: "Default", value: -1 }]),
                    ...this.colorCollection,
                    { label: "Custom...", value: -2 }
                );
            } else {
                colorOptions.push(
                    ...(this.colorDefaultLabel ? [] : [{ label: "Default", value: -1 }]),
                    ...this.colorCollection
                );
            }
            return colorOptions;
        }
    },
    watch: {
        value: {
            handler(val) {
                if (val === null) {
                    this.localValue = this.localValue || -1;
                } else if (val.charAt(0) === "#") {
                    this.customColor = val;
                    this.color = this.customColor;
                    this.localValue = -2;
                } else {
                    this.localValue = val;
                    this.color = this.colorValue[val].value;
                }
            },
            immediate: true
        }
    },
    methods: {
        colorsToOptions(colors) {
            const addDefaultLabel = (v) => (this.colorDefaultLabel === v ? `${v} (default)` : v);
            return colors.map(color => {
                const colorData = {
                    label: addDefaultLabel(color.label),
                    value: color.value,
                    icon: "mdi-checkbox-blank-circle"
                };

                if (color.theme) {
                    colorData.theme = true;
                    colorData.sublabel = "Theme dependent";
                } else {
                    color.theme = false;
                    colorData.color = color.value;
                    colorData.sublabel = color.value;
                }
                return colorData;
            });
        },
        updateValue(value) {
            if (value === -1) {
                this.color = null;
                this.$emit("input", this.color);
            } else if (value === -2) {
                this.color = this.customColor;
                this.$emit("input", this.color);
                this.$nextTick(() => {
                    this.$refs.colorPick.show();
                });
            } else {
                this.color = null;
                this.$emit("input", value);
            }
        },
        updateCustom(value) {
            this.customColor = value;
            if (this.localValue === -2) {
                this.$emit("input", value);
            }
        }
    }
};
